import React from 'react';
import Styles from './checking-account-overview-styles.scss';
import { ButtonKVBase } from '@/presentation/components';
import { IconArrowDownCircle, IconArrowUp, IconReceiptItem } from '@/presentation/components/icons';
import TransferFundsModal from '@/presentation/pages/transfer-funds-modal/transfer-funds-modal';
import { useNavigate } from 'react-router';
import useStudentAccounts from '@/presentation/hooks/use-student-accounts';
import { formatStringAccountBalance } from '@/presentation/utils/money-utils';
const CheckingAccountOverview = ({ validationTransferFunds, showViewButton, manageVirtualTransactions, onTransferCompleted }) => {
    const [openModalFunds, setOpenModalFunds] = React.useState(false);
    const [accountFromParam, setAccountFromParam] = React.useState(null);
    const [accountToParam, setAccountToParam] = React.useState(null);
    const nagivate = useNavigate();
    const { checkingAccount } = useStudentAccounts(true);
    const deposit = () => {
        var _a;
        setOpenModalFunds(true);
        setAccountFromParam(null);
        setAccountToParam((_a = checkingAccount === null || checkingAccount === void 0 ? void 0 : checkingAccount.id) === null || _a === void 0 ? void 0 : _a.toString());
    };
    const withdraw = () => {
        var _a;
        setOpenModalFunds(true);
        setAccountFromParam((_a = checkingAccount === null || checkingAccount === void 0 ? void 0 : checkingAccount.id) === null || _a === void 0 ? void 0 : _a.toString());
        setAccountToParam(null);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: Styles.mainWrap },
            React.createElement("div", { className: "d-flex justify-content-between" },
                React.createElement("div", { className: Styles.title }, "Checking Account"),
                showViewButton && (React.createElement("div", { className: Styles.btnLink, onClick: () => nagivate('/student-dashboard/my-wallet/checking-account') },
                    React.createElement(IconReceiptItem, { color: "#FFA800" }),
                    " View"))),
            React.createElement("div", { className: Styles.bodyWrap },
                React.createElement("div", { className: Styles.t1 }, "Your Balance"),
                React.createElement("div", { className: Styles.t2 },
                    formatStringAccountBalance(checkingAccount === null || checkingAccount === void 0 ? void 0 : checkingAccount.balance),
                    " KV"),
                React.createElement("div", { className: Styles.btnWrap },
                    React.createElement("div", null,
                        React.createElement(ButtonKVBase, { type: "button", btnBackgroundGradient: "linear-gradient(90deg, #00A3FF 0%, #7000FF 100%)", rightIcon: React.createElement(IconArrowUp, null), onClick: deposit }, "Deposit")),
                    React.createElement("div", null,
                        React.createElement(ButtonKVBase, { type: "button", btnBackgroundGradient: "linear-gradient(90deg, #FFA800 0%, #7F1BFF 100%)", rightIcon: React.createElement(IconArrowDownCircle, null), onClick: withdraw }, "Withdraw"))))),
        React.createElement(TransferFundsModal, { openModal: openModalFunds, setOpenModal: setOpenModalFunds, validationTransferFunds: validationTransferFunds, manageVirtualTransactions: manageVirtualTransactions, accountFromParam: accountFromParam, accountToParam: accountToParam, onTransferCompleted: onTransferCompleted })));
};
export default CheckingAccountOverview;
